let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dkoSS")).then(() => parcelRequire('nKMhs'));